import React, { useMemo } from 'react';
import Box from '@mui/material/Box';

import { getAnswerColor } from '../../betLabels';

const formatRate = (rate) => {
  if (rate === null || rate === undefined || rate === '' || rate === '-') {
    return null;
  }

  const numericRate = Number(rate);
  return Number.isFinite(numericRate) ? numericRate.toFixed(2) : String(rate);
};

function MemberMyBetSummary({ choices = [], expectedPayouts = [], loading = false }) {
  const myBet = useMemo(() => {
    const payout = expectedPayouts.find((item) => Number(item?.bet ?? item?.total_point ?? 0) > 0);

    if (!payout) {
      return null;
    }

    const selectedIndex = Number(payout.selection);
    const amount = Number(payout.bet ?? payout.total_point ?? 0);

    return {
      amount,
      choiceLabel: choices[selectedIndex] || `選択肢 ${selectedIndex + 1}`,
      color: getAnswerColor(selectedIndex),
      rate: formatRate(payout.rate),
      refundPoint: Number(payout.refund_point ?? payout.refundPoint ?? 0),
      selectedIndex,
    };
  }, [choices, expectedPayouts]);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: '18px',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.96) 100%)',
        border: '1px solid rgba(15, 23, 42, 0.10)',
        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)',
      }}
    >
      <Box
        sx={{
          mb: 1.25,
          color: 'rgba(15, 23, 42, 0.72)',
          fontSize: '12px',
          fontWeight: 900,
          letterSpacing: '0.08em',
        }}
      >
        あなたの予想
      </Box>

      {myBet ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              alignSelf: 'flex-start',
              px: 1.5,
              py: 0.75,
              maxWidth: '100%',
              borderRadius: 999,
              bgcolor: myBet.color.surface,
              border: `1px solid ${myBet.color.border}`,
              color: myBet.color.primary,
              fontSize: '16px',
              fontWeight: 900,
            }}
          >
            <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {myBet.choiceLabel}
            </Box>
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
              gap: 1,
            }}
          >
            <Box sx={{ p: 1.25, borderRadius: '12px', bgcolor: 'rgba(15, 23, 42, 0.05)' }}>
              <Box sx={{ mb: 0.25, color: 'rgba(15, 23, 42, 0.58)', fontSize: '12px', fontWeight: 800 }}>
                ベット額
              </Box>
              <Box sx={{ color: 'rgba(15, 23, 42, 0.92)', fontSize: '18px', fontWeight: 900 }}>
                {myBet.amount}pt
              </Box>
            </Box>

            {myBet.rate && (
              <Box sx={{ p: 1.25, borderRadius: '12px', bgcolor: 'rgba(15, 23, 42, 0.05)' }}>
                <Box sx={{ mb: 0.25, color: 'rgba(15, 23, 42, 0.58)', fontSize: '12px', fontWeight: 800 }}>
                  ベット時レート
                </Box>
                <Box sx={{ color: 'rgba(15, 23, 42, 0.92)', fontSize: '18px', fontWeight: 900 }}>
                  {myBet.rate}
                </Box>
              </Box>
            )}

            <Box sx={{ p: 1.25, borderRadius: '12px', bgcolor: 'rgba(15, 23, 42, 0.05)' }}>
              <Box sx={{ mb: 0.25, color: 'rgba(15, 23, 42, 0.58)', fontSize: '12px', fontWeight: 800 }}>
                的中時の予想配当
              </Box>
              <Box sx={{ color: 'rgba(15, 23, 42, 0.92)', fontSize: '18px', fontWeight: 900 }}>
                {myBet.refundPoint}pt
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={{ color: 'rgba(15, 23, 42, 0.62)', fontSize: '14px', fontWeight: 700 }}>
          {loading ? 'ベット内容を確認しています。' : 'このラウンドに参加していません。'}
        </Box>
      )}
    </Box>
  );
}

export default MemberMyBetSummary;
